import { DefaultButton, IContextualMenuItem, IContextualMenuProps } from "@fluentui/react";
import { useEffect, useRef } from "react";
import { Utils } from "../../common/views/Utils";
import { PopUpType } from "../../home/models/OtherTypes";
import { PictureModel, FileType, FileCategory } from "../models/PictureModel";
import { IPictureService, usePictureVM } from "../viewmodels/PictureVM";
import AddPictureListView from "./AddPictureListView";
import EditPictureListView from "./EditPictureListView";
import { PictureUtils } from "./PictureUtilities";

export type onGetPicturesCallback = (pictures: PictureModel[]) => void;

type ManagePictureProps = {
    ownerId: any;
    isReadonly: boolean;
    service: IPictureService;
}

export default function ManagePictureView({ ownerId, isReadonly, service }: ManagePictureProps) {
    const hasLoaded = useRef(false);
    const vm = usePictureVM(ownerId, isReadonly, service);

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getList();
    }, [vm]);

    const url = vm.selectedPicture ? vm.selectedPicture.imageUrl : "";
    const type = vm.selectedPicture ? vm.selectedPicture.type : FileType.image;
    const isMobile = Utils.isMobile();

    const menuItems = (): IContextualMenuItem[] => {
        const items = [];

        items.push({
            key: 'create',
            onClick: () => {
                vm.setPictures([]);
                vm.setShowAdd(true);
            },
            iconProps: { iconName: 'Add' },
            text: 'Add'
        });

        items.push({
            key: 'edit',
            onClick: () => vm.setShowEdit(true),
            iconProps: { iconName: 'Edit' },
            text: 'Edit'
        });

        items.push({
            key: 'delete',
            onClick: vm.del,
            iconProps: { iconName: 'Add' },
            text: 'Delete Selected Picture'
        });

        items.push({
            key: 'refresh',
            onClick: vm.getList,
            iconProps: { iconName: 'Refresh' },
            text: 'Refresh'
        });

        return items;
    }

    const commandMenuProps: IContextualMenuProps = {
        shouldFocusOnMount: true,
        items: menuItems()
    };

    const onRenderMiniPicture = (picture: PictureModel) => {
        var text = "";

        if (!isReadonly) {
            text = (picture.isPrimary ? "Primary, " : "");
            text += "Category: " + FileCategory[picture.category];
            text += ", Size: " + (picture.length / 1024).toFixed(2) + " KB";
            text += ", Name: " + picture.fileName;
        }

        return <div key={picture.id} className="mr-10">
            {PictureUtils.getMiniPicture(
                picture.type,
                picture.imageUrl,
                text, () => vm.setSelectedPicture(picture)
            )}
        </div>;
    }

    return <>
        <div className="pb-10 right">
            {!isReadonly && <>
                <DefaultButton
                    menuProps={commandMenuProps}
                    className="context-menu-text"
                    style={{ backgroundColor: "white", height: 32, paddingLeft: 10 }}>
                    Actions
                </DefaultButton>
            </>}
        </div>

        {PictureUtils.getLargePicture(type, url, () => { })}

        <div
            className="pv-20"
            style={{ display: "inline-flex", overflowX: "scroll", maxWidth: "100%" }}
        >
            {vm.pictures.map(onRenderMiniPicture)}
        </div>

        {vm.showAdd && <>
            <AddPictureListView
                popupType={PopUpType.modal}
                prefix=""
                pictures={vm.uploadPictures}
                setPictures={vm.setUploadPictures}
                loading={vm.loading}
                listHash={vm.listHash}
                setListHash={vm.setListHash}
                onValueChange={vm.updateUploadPictureField}
                onCreateList={vm.createList}
                onClose={() => vm.setShowAdd(false)} />
        </>}

        {vm.showEdit && <>
            <EditPictureListView
                pictures={vm.editPictures}
                loading={vm.loading}
                onValueChange={vm.updateEditPictureField}
                onEditList={vm.editList}
                onClose={() => vm.setShowEdit(false)} />
        </>}
    </>;
}